import { wrapExpressionForRender } from '../../../utils/react-utils';

export interface CaseProps {
  value: string;
}
const Case: React.FC<CaseProps> = ({ value, children }) =>
  wrapExpressionForRender(children);
export default Case;
